import axios from 'axios'
import { endpoints } from '../api/endpoints'
import { API } from './comunApi'

export const tasksApi = {
  newTasks: (params) => API.post(endpoints.NEW_TASKS, params),
  updateTasks: (params) => API.put(endpoints.UPDATE_TASKS, params),

  getTasksById: async (id) => {
    return await API.get(endpoints.GET_TASKS_BY_ID(id))
  },

  deleteTasks: async (id) => {
    return await API.delete(endpoints.DELETE_TASKS(id))
  },
}
